/** Query param the server appends to every emailed reschedule URL; the value is a per-meeting secret. */
export const RESCHEDULE_TOKEN_PARAM = 't';

/** The token is forwarded to the availability read in this header so it never enters a request URL. */
export const RESCHEDULE_TOKEN_HEADER = 'x-blockit-reschedule-token';

/** `theme.ts`'s `filled` resolver draws a hairline that `@blockit/ui`'s `default` variant has no equivalent for. */
export const BUTTON_HAIRLINE_CLASS = 'border-black';

/** The `outline` hairline needs both halves: the variant ships a `dark:border-input` an unprefixed class cannot outrank. */
export const OUTLINE_HAIRLINE_CLASS = 'border-foreground dark:border-foreground';

/** `@blockit/ui`'s `destructive` variant is a tint, so a solid red button has to paint itself. */
export const DESTRUCTIVE_FILLED_CLASS = 'bg-destructive text-destructive-foreground hover:bg-destructive/80';
